import { Edit, MoreHoriz } from '@mui/icons-material';
import { Chip, useMediaQuery, useTheme } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButtonLink } from '~/components/button';
import type { ChannelGuideList__ChannelGuide as ChannelGuide } from '../../queries/list.generated';
import { Menu } from '../components/menu';

export const useColumns = (): GridColDef<ChannelGuide>[] => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallAndUp = useMediaQuery(theme.breakpoints.up('sm'));

  return useMemo(
    () => [
      {
        field: 'name',
        flex: 1,
        headerName: t('common.labels.name'),
      },
      {
        field: 'channels',
        headerName: t('pages.channel_guides.list.columns.channels'),
        sortable: false,
        renderCell: ({ row }) => {
          return <Chip color="primary" label={row.channelCount} />;
        },
        minWidth: 50,
      },
      {
        field: 'shows',
        headerName: t('common.tabs.shows'),
        sortable: false,
        renderCell: ({ row }) => {
          return <Chip color="primary" label={row.showCount} />;
        },
        minWidth: 50,
      },
      {
        field: 'actions',
        type: 'actions',
        minWidth: isSmallAndUp ? 150 : 0,
        getActions: ({ row }) => {
          return [
            <ActionButtonLink
              key={`edit-${row.id}`}
              title={t('common.actions.edit')}
              Icon={Edit}
              to={`${row.id}`}
            />,
            <Menu
              key={`more-action-${row.id}`}
              channelGuide={row}
              Icon={MoreHoriz}
              buttonType="action"
            />,
          ];
        },
      },
    ],
    [isSmallAndUp, t],
  );
};
